import { useQuery } from '@tanstack/react-query';
import { useNavigate } from 'react-router-dom';
import { ChevronLeft } from 'lucide-react';
import { api } from '@/lib/api';
import { useFavourites } from '@/lib/favourites';
import { useCategoryMap } from '@/lib/useCategoryMap';
import RecipeCard from '@/components/RecipeCard';

export default function Favourites() {
  const navigate = useNavigate();
  const { favourites } = useFavourites();
  const { byId: categoriesById } = useCategoryMap();
  const recipesQuery = useQuery({ queryKey: ['recipes', null], queryFn: () => api.listRecipes() });

  const recipes = (recipesQuery.data ?? []).filter((r) => favourites.has(r.id));

  return (
    <div className="mx-auto w-full max-w-[520px] px-5 pb-16 sm:max-w-3xl lg:max-w-5xl">
      <button
        type="button"
        onClick={() => navigate(-1)}
        className="inline-flex items-center gap-1 pt-6 text-sm text-text-muted"
      >
        <ChevronLeft size={18} /> Zpět
      </button>
      <h1 className="mt-3 font-serif text-2xl font-extrabold text-text">Oblíbené</h1>
      <p className="text-sm text-text-muted">{recipes.length} uložených receptů</p>

      {recipes.length === 0 ? (
        <div className="mt-6 rounded-2xl border border-dashed border-border p-10 text-center text-text-muted">
          <p className="font-serif text-lg text-text">Zatím žádné oblíbené</p>
          <p className="mt-1 text-sm">Otevři recept a klepni na srdíčko.</p>
        </div>
      ) : (
        <div className="grid grid-cols-2 gap-3 pt-5 sm:grid-cols-3 lg:grid-cols-4">
          {recipes.map((r) => (
            <RecipeCard
              key={r.id}
              recipe={r}
              categoriesById={categoriesById}
              className="h-44"
              favourite
            />
          ))}
        </div>
      )}
    </div>
  );
}
